import React, { useState } from "react";
import {
  TextField,
  Button,
  Box,
  Alert,
  Stack,
  InputAdornment,
  Checkbox,
  FormControlLabel,
} from "@mui/material";
import GolfCourseIcon from "@mui/icons-material/GolfCourse";
import EventIcon from "@mui/icons-material/Event";
import NotesIcon from "@mui/icons-material/Notes";
import { useAuth } from "react-oidc-context";
import CircularProgress from "@mui/material/CircularProgress";

export default function BirdieForm() {
  const auth = useAuth();
  const token = auth.user?.access_token || auth.user?.id_token;
  const [form, setForm] = useState({
    date: "",
    course: "",
    hole: "",
    notes: "",
    eagle: false,
  });
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm({
      ...form,
      [name]: type === "checkbox" ? checked : value,
    });
    setError("");
    setMessage("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage("");
    setError("");
    setLoading(true);
    try {
      if (!token) {
        setError("You must be signed in to submit a birdie.");
        return;
      }

      const res = await fetch(
        "https://elk87mfiog.execute-api.us-east-1.amazonaws.com/birdie",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`
          },
          body: JSON.stringify(form),
        }
      );
      const data = await res.json();
      if (res.ok) {
        const msg = form.eagle ? "Eagle logged!" : (data.message || "Birdie logged!");
        setMessage(msg);
        console.log(msg);
        setForm({ date: "", course: "", hole: "", notes: "", eagle: false });
      } else {
        setError(data.message || "Failed to log birdie.");
        console.log(data.message || "Failed to log birdie.");
      }
    } catch (err) {
      setError("Error: " + err.message);
      console.log("Error: " + err.message);
    }
    setLoading(false);
  };

  if (loading) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", mt: 8 }}>
        <CircularProgress size={60} />
      </Box>
    );
  }

  return (
    <>
      {/* <img
        src="/logo192.png"
        alt="Logo192"
        width={100}
        height={100}
        style={{ display: "block", margin: "0 auto" }}
      /> */}
      <Box
        component="form"
        onSubmit={handleSubmit}
        sx={{
          mt: 2,
          maxWidth: 400,
          mx: "auto",
          p: 3,
          borderRadius: 2,
          boxShadow: 3,
          backgroundColor: "#fff",
        }}
      >
        <Stack spacing={2}>
          {message && <Alert severity="success">{message}</Alert>}
          {error && <Alert severity="error">{error}</Alert>}
          <TextField
            label="Date"
            name="date"
            type="date"
            value={form.date}
            onChange={handleChange}
            InputLabelProps={{ shrink: true }}
            required
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <EventIcon />
                </InputAdornment>
              ),
            }}
          />
          <TextField
            label="Course"
            name="course"
            value={form.course}
            onChange={handleChange}
            required
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <GolfCourseIcon />
                </InputAdornment>
              ),
            }}
          />
          <TextField
            label="Hole"
            name="hole"
            type="number"
            value={form.hole}
            onChange={handleChange}
            required
            inputProps={{ min: 1, max: 18 }}
          />
          <TextField
            label="Notes"
            name="notes"
            value={form.notes}
            onChange={handleChange}
            multiline
            minRows={2}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <NotesIcon />
                </InputAdornment>
              ),
            }}
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={form.eagle}
                onChange={handleChange}
                name="eagle"
                color="primary"
              />
            }
            label="Eagle"
          />
          <Button
            type="submit"
            variant="contained"
            color="success"
            size="large"
            sx={{ fontWeight: 700 }}
          >
            Log Birdie
          </Button>
        </Stack>
      </Box>
    </>
  );
}